import { hu } from './hu';

// Plan #3: SK keys present for parity. Most values are HU fallback;
// Plan #5 sweeps for translation polish.
export const sk: Record<keyof typeof hu, string> = {
  ...hu,
  'header.brand': 'Denný 11-er',
  'header.mute':   'Stlmiť zvuk',
  'header.unmute': 'Zapnúť zvuk',
  'menu.play': 'Kopni!',
  'outcome.goal':  'GÓL!',
  'outcome.saved': 'CHYTIL!',
  'outcome.miss':  'VEDĽA!',
  'share.shareButton': 'Zdieľať',
  'share.copyButton': 'Kopírovať',
  'settings.title': 'Nastavenia',
  'settings.cancel': 'Zrušiť',
  'settings.confirm': 'Potvrdiť',
  'settings.hardMode': '🕶️ Ťažký režim',
  'settings.hardModeHelp': 'Skryje kartu dnešného brankára pred zápasom. Rovnaké ihrisko, rovnaké body.',
  'settings.assist': '💡 Pomoc',
  'settings.assistHelp': 'Po 5. strele ukáže zónu s nízkou pravdepodobnosťou. Tým sa vzdáš značky 🕶️.',

  // TODO(Plan #5 i18n native pass) — SK strings below are approximate; need native review.
  'badge.hawkEye':   'Sokolie oko',
  'badge.hatTrick':  'Hetrik',
  'badge.perfect':   'Perfektný',
  'badge.ironDoor':  'Železné dvere',
  'badge.brilliant': 'Brilantný',
  'result.communityLine': 'Ty: {self} · Komunita: {avg}',
  'archetype.heatmapHintPreplay': 'Ešte sa neukázal',
  'archetype.heatmapHintLive':    'Koľkokrát si tam videl skočiť?',
  'archetype.cellObservedCount':  '{count}×',
  'archetype.cellHiddenA11y':     '{position}, ešte si tam nevidel ísť brankára',
  'archetype.cellSeenA11y':       '{position}, {count}× si videl ísť',
  'archetype.cellTruthA11y':      '{position}, {pct} %',
  'archetype.truthLabelTop':      'Obranná mapa brankára',
  'archetype.DIVER.truthTakeaway':         'Vrhá sa do oboch horných rohov — takmer vždy do strán.',
  'archetype.HIGH_WALL.truthTakeaway':     'Bráni horný rad — hore je ťažké skórovať.',
  'archetype.LEFT_LEANER.truthTakeaway':   'Bráni svoju ľavú stranu — ťahá tam.',
  'archetype.CENTER_SPREAD.truthTakeaway': 'Drží sa stredu — hore aj dole sa vrhá do stredu.',
  'archetype.WIDE_OPEN.truthTakeaway':     'Nemá obľúbenú zónu — môže sa vrhnúť kamkoľvek.',
  'archetype.TWO_CLUSTER.truthTakeaway':   'Bráni dva uhlopriečne rohy — ľavý dolný a pravý horný.',
  'archetype.position.LA': 'Ľavý horný roh',
  'archetype.position.CA': 'Stredný horný',
  'archetype.position.RA': 'Pravý horný roh',
  'archetype.position.LF': 'Ľavý dolný roh',
  'archetype.position.CF': 'Stredný dolný',
  'archetype.position.RF': 'Pravý dolný roh',
  'assist.revealZone': 'Ukáž šancu',
  'assist.hintCaption': 'Najmenšia šanca teraz: {position}',

  // Plan #6 — personal Statisztika (approximate, TODO native pass)
  'result.streakDays':  'deň',
  'result.day1Welcome': 'Tvoj prvý deň!',
  'result.day2Welcome': 'Tvoj druhý deň!',

  'personalStats.title':             'Štatistika',
  'personalStats.titleWithUnseen':   'Štatistika – nový odznak',
  'personalStats.daysPlayed':        'Odohrané dni',
  'personalStats.currentStreak':     'Aktuálna séria',
  'personalStats.longestStreak':     'Najdlhšia séria',
  'personalStats.distribution':      'Rozdelenie',
  'personalStats.engagementBadges':  'Odznaky série',
  'personalStats.performanceBadges': 'Odznaky výkonu',
  'personalStats.empty':             'Zahraj si dnes a začni zbierať odznaky!',
  'personalStats.locked':            'Ešte nezískané',
  'personalStats.newBadgeAnnounce':  'Nový odznak: {name}',

  'engagementBadge.firstKick': 'Prvý výkop',
  'engagementBadge.rookie':    'Nováčik',
  'engagementBadge.regular':   'Pravidelný',
  'engagementBadge.weekly':    'Týždenný',
  'engagementBadge.biweekly':  'Dvojtýždňový',
  'engagementBadge.monthly':   'Mesačný',

  // Practice (Plan #9 §4.2)
  'practice.again': 'Tréning',
  'practice.bannerActive': 'Tréningové kolo — nepočíta sa',
  'practice.backToResult': 'Späť na výsledok',
};
